import {
  SURVEYTEMPLATE_LOADING,
  GET_SURVEYTEMPLATE,
  GET_SURVEYTEMPLATE_SUCCESS,
  GET_SURVEYTEMPLATE_FAIL,
  ADD_SURVEYTEMPLATE_SUCCESS,
  ADD_SURVEYTEMPLATE_FAIL,
  DELETE_SURVEYTEMPLATE_SUCCESS,
  DELETE_SURVEYTEMPLATE_FAIL,
  UPDATE_SURVEYTEMPLATE_SUCCESS,
  UPDATE_SURVEYTEMPLATE_FAIL,
  SURVEYTEMPLATE_RESET,
  SURVEYTEMPLATE_RESET_CREATE,
} from "./actionType";

const INIT_STATE = {
  surveyTemplates: [],
  surveyTemplateAdded: {},
  error: {},
};

const SurveyTemplate = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SURVEYTEMPLATE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SURVEYTEMPLATE:
          return {
            ...state,
            surveyTemplates: action.payload.data,
            isSurveyTemplateCreated: false,
            isSurveyTemplateSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SURVEYTEMPLATE_FAIL:
      switch (action.payload.actionType) {
        case GET_SURVEYTEMPLATE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSurveyTemplateCreated: false,
            isSurveyTemplateSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SURVEYTEMPLATE: {
      return {
        ...state,
        isSurveyTemplateCreated: false,
        loading: true,
      };
    }

    case SURVEYTEMPLATE_LOADING: {
      return {
        ...state,
        isSurveyTemplateCreated: false,
        loading: true,
      };
    }

    case ADD_SURVEYTEMPLATE_SUCCESS:
      return {
        ...state,
        isSurveyTemplateCreated: true,
        loading: false,
        surveyTemplates: [action.payload.data, ...state.surveyTemplates],
        surveyTemplateAdded: action.payload.data,
      };

    case ADD_SURVEYTEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SURVEYTEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        surveyTemplates: state.surveyTemplates.filter(
          (surveyTemplate) =>
            surveyTemplate.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SURVEYTEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SURVEYTEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        surveyTemplates: state.surveyTemplates.map((surveyTemplate) =>
          surveyTemplate.id.toString() === action.payload.data.id.toString()
            ? { ...surveyTemplate, ...action.payload.data }
            : surveyTemplate
        ),
      };

    case UPDATE_SURVEYTEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SURVEYTEMPLATE_RESET_CREATE:
      return {
        ...state,
        isSurveyTemplateCreated: false,
      };

    case SURVEYTEMPLATE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SurveyTemplate;
